import youtubeVideoUrlToId from './convertYoutubeUrlToId';

export default function processYoutubeUrl(rawUrl: string) {
  const videoId = youtubeVideoUrlToId(rawUrl);

  // add options to url
  return `https://www.youtube.com/embed/${videoId}?autoplay=0&disablekb=0&loop=1&modestbranding=1&rel=0&playlist=${videoId}`;
}
